export default __webpack_public_path__ + "static/media/80t.905be2e5.jpg";